var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip"},[_c('i',{staticClass:"far fa-question-circle"}),_vm._v(" "),(_vm.text)?_c('span',{staticClass:"tooltiptext",class:{left: _vm.left}},[_vm._v(_vm._s(_vm.text))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }